import { render } from "./Cake.vue?vue&type=template&id=d691cb74"
const script = {}

import exportComponent from "../../../../../../../../projects/loyalzilla_admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/icons/Cake.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d691cb74"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d691cb74', __exports__)) {
    api.reload('d691cb74', __exports__)
  }
  
  module.hot.accept("./Cake.vue?vue&type=template&id=d691cb74", () => {
    api.rerender('d691cb74', render)
  })

}


export default __exports__